// extracted by mini-css-extract-plugin
export default {"container":"TradingViewWidget_container__1-bj-"};